import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicRestService } from '@generated/be';
import { publicApiArgs } from '@shared/utils';

@Component({
  selector: 'reza-warning-text-field',
  standalone: true,
  imports: [CommonModule],
  providers: [PublicRestService],
  templateUrl: './warning-text-field.component.html',
  styleUrl: './warning-text-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningTextFieldComponent implements OnInit {
  private publicService = inject(PublicRestService);
  private cd = inject(ChangeDetectorRef);

  textUpozorneni: string | undefined = undefined;

ngOnInit(): void {
  this.publicService.vypisUpozorneni(...publicApiArgs()).subscribe((res) => {
    this.textUpozorneni = res.popisUpozorneni;
    this.cd.detectChanges();
  });
}
}
